import LeftSide from "/components/layouts/leftSide";
import InfoMenu from "../../components/pages/faq/menu";
import { wrapper } from "../../redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import Redis from "/lib/redis";
import { useSelector } from "react-redux";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { sspWrapper } from "../../utils/errors/sspWrapper";

export default function WarrantyPage({ scripts, host, isBaltex }) {
  const { content } = useSelector((state) => state.meta);
  const { contacts } = useSelector((state) => state.contacts);

  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <LeftSide
        isBaltex={isBaltex}
        side={<InfoMenu isBaltex={isBaltex}></InfoMenu>}
        title="Гарантия"
      >
        <div className={"text"}>
          <div
            dangerouslySetInnerHTML={{
              __html: content
                ?.replaceAll("#PHONE#", contacts?.phone)
                .replaceAll("#CALL_TOUCH_CODE#", contacts?.calltouchCode),
            }}
          />
        </div>
      </LeftSide>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ req, query, resolvedUrl }) => {
    store.dispatch(addBreadcrumb({ link: "/warranty/", name: "Гарантия" }));

    return pagesWrapper(
      { pageType: SITE_PAGE_TYPE.static },
      store,
      Redis,
      {
        req,
        query,
        resolvedUrl,
      },
      "/warranty/",
    );
  }),
);
